module.exports = __webpack_public_path__ + "img/101.fe7605a7.jpg";